import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Package, Clock, Shield, AlertCircle } from 'lucide-react';

const Delivery = () => {
  return (
    <div className="min-h-screen bg-junto-cream py-16">
      <Helmet>
        <title>Teslimat Koşulları - JUNTO® Kahve</title>
        <meta name="description" content="JUNTO® Kahve teslimat koşulları, kargo süreci ve teslimat bilgileri." />
      </Helmet>

      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="flex justify-center mb-4">
              <Package className="w-16 h-16 text-junto-red" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Teslimat Koşulları
            </h1>
            <p className="text-lg text-gray-600">
              JUNTO® Kahve teslimat ve kargo bilgilendirmesi
            </p>
          </div>

          {/* Content */}
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 space-y-8">
            
            {/* Teslimat Süresi */}
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <Clock className="w-8 h-8 text-junto-red mt-1" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Teslimat Süresi</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Siparişleriniz, banka onayı alındıktan sonra <strong>3 iş günü (Pazartesi-Cuma)</strong> içerisinde kargoya teslim edilir.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Tarafımızdan kaynaklanan bir aksilik olması halinde ise size üyelik bilgilerinizden yola çıkılarak haber verilecektir. Bu yüzden üyelik bilgilerinizin eksiksiz ve doğru olması önemlidir. <strong>Bayram ve tatil günlerinde teslimat yapılmamaktadır.</strong>
                </p>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-8"></div>

            {/* Kargo Firması */}
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <Shield className="w-8 h-8 text-junto-red mt-1" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Kargo ve Teslimat</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Seçtiğiniz ürünlerin tamamı anlaşmalı olduğumuz kargo şirketleri tarafından <strong>Yurtiçi Kargo</strong> garantisi ile size teslim edilecektir.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Satın aldığınız ürünler bir teyit e-posta'sı ile tarafınıza bildirilecektir. Seçtiğiniz ürünlerden herhangi birinin stokta mevcut olmaması durumunda konu ile ilgili bir e-posta size yollanacak ve ürünün ilk stoklara gireceği tarih tarafınıza bildirilecektir.
                </p>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-8"></div>

            {/* Stok Durumu */}
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <AlertCircle className="w-8 h-8 text-junto-red mt-1" />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">Stok Durumu ve Bekleme Süreleri</h2>
                <p className="text-gray-700 leading-relaxed mb-4">
                  <strong>juntokahve.com</strong> online alışveriş sitesidir. Aynı anda birden çok kullanıcıya alışveriş yapma imkanı tanır. Ender de olsa tüketicinin aynı ürünü alması söz konusudur ve ürün stoklarda tükenmektedir bu durumda;
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Ödemesini internet üzerinden yaptığınız ürün eğer stoklarımızda kalmamış ise <strong>en az 4 (dört) en fazla 30 (otuz) gün</strong> bekleme süresi vardır. Ürün bu tarihler arasında tüketiciye verilemez ise yaptığı ödeme kendisine iade edilir.
                </p>
              </div>
            </div>

            {/* İletişim Kutusu */}
            <div className="bg-gradient-to-r from-junto-red/10 to-orange-100 rounded-xl p-6 mt-8">
              <h3 className="text-lg font-bold text-gray-900 mb-2">Sorularınız mı var?</h3>
              <p className="text-gray-700 mb-4">
                Teslimat süreciyle ilgili herhangi bir sorunuz varsa, müşteri hizmetlerimizle iletişime geçebilirsiniz.
              </p>
              <div className="flex flex-wrap gap-4">
                <a 
                  href="tel:+905533812134" 
                  className="inline-flex items-center px-4 py-2 bg-junto-red text-white rounded-lg hover:bg-junto-red-dark transition-colors"
                >
                  📞 0 (553) 381 21 34
                </a>
                <a 
                  href="mailto:mehmet@juntokahve.com" 
                  className="inline-flex items-center px-4 py-2 bg-white text-junto-red border-2 border-junto-red rounded-lg hover:bg-junto-red hover:text-white transition-colors"
                >
                  ✉️ mehmet@juntokahve.com
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Delivery;
